import {
  RouterState,
  connectRouter,
  routerMiddleware,
} from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunk from 'redux-thunk'

import categoriesReducer from './categories/categoriesReducer'
import { CategoriesState } from './categories/categoriesTypes'
import dashboardReducer from './dashboard/dashboardReducer'
import { DashboardState } from './dashboard/dashboardTypes'
import drawerReducer from './drawer/drawerReducer'
import { DrawerState } from './drawer/drawerTypes'
import peopleReducer from './people/peopleReducer'
import { PeopleState } from './people/peopleTypes'
import sessionReducer from './session/sessionReducer'
import { SessionState } from './session/sessionTypes'
import snacksReducer from './snacks/snacksReducer'
import { SnacksState } from './snacks/snacksTypes'
import transactionsReducer from './transactions/transactionsReducer'
import { TransactionsState } from './transactions/transactionsTypes'
import transfersReducer from './transfers/transfersReducer'
import { TransfersState } from './transfers/transfersTypes'
import patrimonyReducer from './patrimony/patrimonyReducer'
import { PatrimonyState } from './patrimony/patrimonyTypes'
import paymentReducer from './payments/paymentReducer'
import { PaymentState } from './payments/paymentTypes'
import alertsUserReducer from './alertsUser/alertsUserReducer'
import { AlertsUserState } from './alertsUser/alertsUserTypes'

export interface StoreState {
  sessionState: SessionState
  snacksState: SnacksState
  peopleState: PeopleState
  transactionsState: TransactionsState
  drawerState: DrawerState
  dashboardState: DashboardState
  transfersState: TransfersState
  categoriesState: CategoriesState
  patrimonyState: PatrimonyState
  paymentState: PaymentState
  alertsUserState: AlertsUserState
  router: RouterState
}

export const history = createBrowserHistory()

const middlewares = [
  applyMiddleware(routerMiddleware(history)),
  applyMiddleware(thunk),
  // @ts-ignore
  ...(window.__REDUX_DEVTOOLS_EXTENSION__ ? [window.__REDUX_DEVTOOLS_EXTENSION__()] : []),
]

const store = createStore(
  combineReducers({
    sessionState: sessionReducer,
    snacksState: snacksReducer,
    peopleState: peopleReducer,
    transactionsState: transactionsReducer,
    drawerState: drawerReducer,
    dashboardState: dashboardReducer,
    transfersState: transfersReducer,
    categoriesState: categoriesReducer,
    patrimonyState: patrimonyReducer,
    paymentState: paymentReducer,
    alertsUserState: alertsUserReducer,
    router: connectRouter(history),
  }),
  compose(...middlewares)
)

export default store
